(() => {
  const sliders = new Map();

  const mountSlider = (container) => {
    if (!window.Splide) return;

    const mainSlider = container.querySelector(':scope > .shop-the-look__inner > .shop-the-look__slider');
    if (mainSlider && !sliders.has(mainSlider)) {
      const slideCount = mainSlider.querySelectorAll(':scope > .splide__track > .splide__list > .splide__slide').length;

      const splide = new Splide(mainSlider, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        arrows: slideCount > 1,
        pagination: false,
        speed: 750,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        drag: slideCount > 1,
        keyboard: 'focused',
        breakpoints: {
          767: {
            focus: 'center',
            trimSpace: false,
            padding: { left: '2.5rem', right: '2.5rem' },
            gap: '1rem',
          }
        }
      });

      splide.mount();
      sliders.set(mainSlider, splide);
    }

    container.querySelectorAll('.shop-the-look__slide').forEach((slideElement) => {
      const sliderElement = slideElement.querySelector('.shop-the-look__products');
      if (!sliderElement || sliders.has(sliderElement)) return;

      const hotspots = slideElement.querySelectorAll('.shop-the-look__hotspot');
      const slideCount = sliderElement.querySelectorAll('.splide__slide').length;

      const splide = new Splide(sliderElement, {
        type: 'fade',
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: slideCount > 1,
        speed: 550,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        drag: slideCount > 1,
        keyboard: 'focused',
      });

      hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', () => {
          const index = parseInt(hotspot.getAttribute('data-index'), 10);
          if (!isNaN(index)) {
            splide.go(index);
          }
        });
      });

      splide.on('move', (newIndex) => {
        hotspots.forEach((hotspot) => {
          const index = parseInt(hotspot.getAttribute('data-index'), 10);
          if (index === newIndex) {
            hotspot.classList.add('is-active');
          } else {
            hotspot.classList.remove('is-active');
          }
        });
      });

      splide.mount();
      sliders.set(sliderElement, splide);
    });
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-shop-the-look]').forEach(mountSlider);
  };

  const destroySlider = (container) => {
    container.querySelectorAll('.splide').forEach((sliderElement) => {
      const splide = sliders.get(sliderElement);
      if (!splide) return;

      splide.destroy(true);
      sliders.delete(sliderElement);
    });
  };

  document.addEventListener('DOMContentLoaded', () => mountAll());

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-shop-the-look]').forEach(destroySlider);
  });
})();
